import { Agency } from './lib/agency.model';
import { Blog } from './lib/blog.model';
import { Client } from './lib/client.model';
import {
  contextApps,
  contextMotionDesign,
  MainMenuItem,
} from './lib/menu.model';
import { Page } from './lib/page.model';
import { Paragraphs } from './lib/paragraph.model';
import { Profile } from './lib/profile.model';
import { Project } from './lib/project.model';
import { Solution } from './lib/solution.model';
import { News } from './lib/news.model';
import {
  BusinessUnitTerm,
  ColorTerm,
  DomainTerm,
  SolutionTerm,
  TechnologyTerm,
  TypeTerm,
} from './lib/terms.model';
import {
  DrupalIdentifier,
  DrupalTerm,
  MediaTypes,
} from '@nx-icilalune/drupal-types';
import { Observable } from 'rxjs';
import { UIDate, UIPage } from './lib/ui.model';

export type IciLaLuneTypes =
  | typeof Agency.type
  | typeof Blog.type
  | typeof Client.type
  | typeof News.type
  | typeof MainMenuItem.type
  | typeof Page.type
  | Paragraphs
  | typeof Profile.type
  | typeof Project.type
  | typeof Solution.type
  | MediaTypes
  | typeof TypeTerm.type
  | typeof TechnologyTerm.type
  | typeof DomainTerm.type
  | typeof SolutionTerm.type
  | typeof BusinessUnitTerm.type
  | typeof ColorTerm.type;

// const test: IciLaLuneTypes = '';

export interface IciLaLuneDetailNode extends DrupalIdentifier {
  title?: string | undefined;
  date?: UIDate | undefined;
  description?: string | undefined;
  paragraphs?: DrupalIdentifier[] | undefined;
  media?: DrupalIdentifier[] | undefined;
  associated?: DrupalIdentifier[];
}

export class FilterGroup {
  label?: string;
  filters?: DrupalTerm[];
  id!: 'domains' | 'technologies' | 'businessUnits' | 'types';
}

export type BusinessUnits = typeof contextApps | typeof contextMotionDesign;

export interface IciLaLuneRouteComponent {
  ready$: Observable<boolean>;
}

export * from './lib/agency.model';
export * from './lib/blog.model';
export * from './lib/client.model';
export * from './lib/menu.model';
export * from './lib/news.model';
export * from './lib/page.model';
export * from './lib/paragraph.model';
export * from './lib/profile.model';
export * from './lib/project.model';
export * from './lib/solution.model';
export * from './lib/terms.model';
export * from './lib/ui.model';
